import { Icon } from 'palette/Icon';
import { useConfig } from '@common/Hooks/useConfig';
import { languageSelectId } from './constants/languageSelect';

import './styles/CurrentLanguageIndicator.scss';

export function CurrentLanguageIndicator({ onClick }) {
    const { language } = useConfig();

    return (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
        <div
            className="current-language-indicator"
            data-uuid={languageSelectId}
            onClick={onClick}
        >
            <span className="current-language-indicator__text">{language.toUpperCase()}</span>
            <Icon
                name="palette_chevron_down"
            />
        </div>
    );
}
